import React from "react";
import Breadcrumb2 from "../../../Components/Breadcrumb2/Breadcrumb2";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import AllAcountsSection from "../../../Components/AllAccountsSection/AllAcountsSection";
import { AiOutlineArrowRight, AiOutlineArrowUp } from "react-icons/ai";
import CustomerCare from "../../../Components/CustomerCare/CustomerCare";
import OurStores from "../../../Components/OurStories/OurStores";
import { AiFillCaretRight, AiOutlineRight } from "react-icons/ai";
import { useEffect, useState } from "react";
import axios from 'axios';
import { Link } from "react-router-dom";

const IzbBudgetSymposium = ({ question, answer }) => {
    const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Image_1.png";
    const img1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Forex_Savings.png";

    const ArrowLeft = "https://izbassetsmain.blob.core.windows.net/izbwebassets/LeftArrow.png";
    const ArrowRight = "https://izbassetsmain.blob.core.windows.net/izbwebassets/RightArrow.png";

    function SamplePrevArrow(props) {
        const { className, style, onClick } = props;
        return (
            <img
                src={ArrowLeft}
                className={className}
                style={{
                    ...style,
                    display: "block",
                    width: "50px",
                    height: "50px",
                    left: "-58px",
                    zIndex: "99"
                }}
                onClick={onClick}
            />
        );
    }

    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <img
                src={ArrowRight}
                className={className}

                onClick={onClick}
            />
        );
    }

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <>
            <Breadcrumb2
                Heading="Latest News"
                img={BackgroundBrundcrumb}
                show={true}

            />

            <section>
                <div className="container pt-5">
                    <h1 className="pb-5 text-left">IZB and MOFNP partner to host the National Symposium on 2026 Budget!</h1>


                    <p className="pb-3">Indo Zambia Bank (IZB) Managing Director, Mr. Brajesh Kumar Singh, has reaffirmed the Bank’s unwavering commitment to Zambia’s economic growth and development, speaking during his opening remarks at the National Symposium on the 2026 Budget hosted by the Ministry of Finance and National Planning (MOFNP) at Mulungushi International Conference Centre (MICC).</p>

                    <p className="pb-3">Mr. Singh highlighted that Indo Zambia Bank has achieved key milestones, including:</p>

                    <ul style={{listStyleType: "disc"}}>

                        <li style={{paddingLeft: '12px', paddingBottom: '6px'}}><b style={{paddingRight: '8px'}}>●</b>Disbursement of K400 million to over 3,600 farmers under the Sustainable Agriculture Financing Facility (SAFF)</li>

                        <li style={{paddingLeft: '12px', paddingBottom: '6px'}}><b style={{paddingRight: '8px'}}>●</b>Channeling K1.3 billion into growth sectors through the Stability and Resilience Facility (SRF).</li>

                        <li style={{paddingLeft: '12px', paddingBottom: '6px'}}><b style={{paddingRight: '8px'}}>●</b>Investment of USD 140 million in energy projects expected to add 800 MW of power by Q1 of 2026.</li>

                        <li style={{paddingLeft: '12px', paddingBottom: '6px'}}><b style={{paddingRight: '8px'}}>●</b>Release of K320 million in Constituency Development Fund (CDF) revolving loans, benefiting more than 3,300 citizens.</li>

                        <li style={{paddingLeft: '12px', paddingBottom: '18px'}}><b style={{paddingRight: '8px'}}>●</b>Growth of 20.5% in deposits and 36.9% in advances by August 2025.</li>
                    </ul>

                    <p className="pb-3">Looking ahead, the Bank stands ready to partner with Government in delivering the 2026 Budget priorities from agriculture modernisation and industrialisation to energy diversification, infrastructure development, and expanded financial inclusion.</p>

                    <p className="pb-3"><b><em>#IZB #Budget2026 #EconomicGrowth #Vision2030</em></b></p>




                    <h2 className="pt-4 pb-4">Gallery</h2>

                    <div className="test news-slider-list-slider row align-items-center pb-4">
                        <Slider {...settings}>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-and-mofnp-partner-to-host-the-national-symposium-on-2026-budget-banner-1.jpg" alt="IZB and MOFNP partner to host the National Symposium on 2026 Budget!" />
                            </div>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-and-mofnp-partner-to-host-the-national-symposium-on-2026-budget-banner-2.jpg" alt="IZB and MOFNP partner to host the National Symposium on 2026 Budget!" />
                            </div>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-and-mofnp-partner-to-host-the-national-symposium-on-2026-budget-banner-3.jpg" alt="IZB and MOFNP partner to host the National Symposium on 2026 Budget!" />
                            </div>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-and-mofnp-partner-to-host-the-national-symposium-on-2026-budget-banner-4.jpg" alt="IZB and MOFNP partner to host the National Symposium on 2026 Budget!" />
                            </div>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-and-mofnp-partner-to-host-the-national-symposium-on-2026-budget-banner-5.jpg" alt="IZB and MOFNP partner to host the National Symposium on 2026 Budget!" />
                            </div>
                        </Slider>
                    </div>
                </div>



            </section>

            <CustomerCare />
            <OurStores />

        </>
    );
};

export default IzbBudgetSymposium;